import React, { useContext } from "react";
import { AccountStore } from "../../account/stores/AccountStore";
import { OsaCommentStore } from "../../coding/stores/OsaCommentStore";
import { OsaNodeStore } from "../../osaway/stores/OsaNodeStore";
import { NotificationStore } from "../../notification/stores/NotificationStore";
import { DashboardStore } from "../../project/stores/DashboardStore";
import { ForecastStore } from "../../project/stores/ForecastStore";
import { ProjectStore } from "../../project/stores/ProjectStore";
import { MapStore } from "../../project/stores/MapStore";
import { OsaWayStore } from "../../osaway/stores/OsaWayStore";
import { CodingStore } from "../../coding/stores/CodingStore";
import { CampaignStore } from "../../project/stores/CampaignStore";
import { LoadingStore } from "../../project/stores/LoadingStore";
import { FilterStore } from "../../project/stores/FilterStore";
import { HlaStore } from "../../hla/stores/HlaStore";
import { AuthStore } from "../../auth/stores/AuthStore";
import { MapQueryStore } from "../../project/stores/MapQueryStore";
import { MapillaryStore } from "../../project/stores/MapillaryStore";
import { RouteDesignStore } from "../../project/stores/RouteDesignStore";
import { StreetViewStore } from "./StreetViewStore";

export class RootStore {
  authStore = new AuthStore();
  accountStore = new AccountStore(this);
  notificationStore = new NotificationStore(this);
  projectStore = new ProjectStore(this);
  osaWayStore = new OsaWayStore(this);
  osaNodeStore = new OsaNodeStore(this);
  mapStore = new MapStore(this);
  dashboardStore = new DashboardStore(this);
  forecastStore = new ForecastStore(this);
  osaCommentStore = new OsaCommentStore(this);
  codingStore = new CodingStore(this);
  campaignStore = new CampaignStore(this);
  loadingStore = new LoadingStore(this);
  filterStore = new FilterStore(this);
  hlaStore = new HlaStore(this);
  mapQueryStore = new MapQueryStore(this);
  routeDesignStore = new RouteDesignStore(this);
  mapillaryStore = new MapillaryStore(this);
  streetViewStore = new StreetViewStore(this);
}

interface ContextProps {
  authStore: AuthStore;
  accountStore: AccountStore;
  notificationStore: NotificationStore;
  projectStore: ProjectStore;
  osaWayStore: OsaWayStore;
  osaNodeStore: OsaNodeStore;
  mapStore: MapStore;
  dashboardStore: DashboardStore;
  forecastStore: ForecastStore;
  osaCommentStore: OsaCommentStore;
  codingStore: CodingStore;
  campaignStore: CampaignStore;
  loadingStore: LoadingStore;
  filterStore: FilterStore;
  hlaStore: HlaStore;
  mapQueryStore: MapQueryStore;
  routeDesignStore: RouteDesignStore;
  mapillaryStore: MapillaryStore;
  streetViewStore: StreetViewStore;
}
export const RootStoreContext = React.createContext({} as ContextProps);

export const useStores = () => useContext(RootStoreContext);

interface ProviderProps {
  children: React.ReactNode;
}
export const RootStoreProvider: React.FC<ProviderProps> = ({ children }) => {
  const rootStore = new RootStore();

  return (
    <RootStoreContext.Provider value={rootStore}>
      {children}
    </RootStoreContext.Provider>
  );
};
